<template>
  <section class="groups">
    <form method="post" @submit.prevent="onSend">
      <b-field horizontal :label="$t('attributes.name')">
        <b-input v-model="group_name" disabled expanded></b-input>
      </b-field>

      <b-field horizontal :label="$t('attributes.group_code')">
        <b-input v-model="group_code" disabled expanded></b-input>
      </b-field>

      <hr />

      <b-field horizontal>
        <template #label>
          {{ $t('attributes.related_groups') }}
          <b-tooltip
            type="is-info"
            label="報名表/自選行程已設定的話，複寫報名表/自選行程的步驟會跳過"
          >
            <b-icon
              size="is-small"
              type="is-danger"
              icon="help-circle-outline"
            ></b-icon>
          </b-tooltip>
        </template>
        <div class="columns is-multiline is-mobile">
          <b-checkbox
            v-model="selectedAllGroups"
            class="column is-4 is-marginless"
            @input="onSelectedAllGroups"
          >
            {{ $t('attributes.select_all') }}
          </b-checkbox>
          <b-checkbox
            v-model="showExpiredGroups"
            class="column is-5 is-marginless"
            @input="onShowExpiredGroups"
            style="color:brown;"
          >
            {{ $t('attributes.display_expired') }}
          </b-checkbox>
          <b-checkbox
            v-for="group in groups"
            v-model="form.groups"
            :key="group.code"
            :native-value="group.code"
            class="column is-marginless is-4 is-selectable"
            :class="travelGroup.is_collaborate_travel_group ? 'is-6' : 'is-4'"
            @input="onSelectedGroup"
          >
            <span>{{ group.code }}</span>
            <span
              v-if="!group.shelve_on"
              class="ml-0.5 has-text-danger has-text-weight-bold"
            >
              (下架)
            </span>
            <span
              v-if="group.common_questions.length > 0"
              class="has-text-danger"
            >
              (報名表已設定)
            </span>
            <span
              v-if="group.spot_questions.length > 0"
              class="has-text-danger"
            >
              (自選行程已設定)
            </span>
          </b-checkbox>
          <b-collapse
            :open="false"
            position="is-bottom"
            aria-id="showMore"
            v-if="moreGroups.length > 0"
            style="width: 100%;"
          >
            <template #trigger="props">
              <a
                aria-controls="showMore"
                :aria-expanded="props.open"
                style="font-size: 18px;"
              >
                <b-icon :icon="!props.open ? 'menu-down' : 'menu-up'"></b-icon>
                {{ !props.open ? 'more' : 'hide' }}
              </a>
            </template>
            <b-checkbox
              v-for="group in moreGroups"
              v-model="form.groups"
              :key="group.code"
              :native-value="group.code"
              class="column is-4 is-marginless is-selectable"
              @input="onSelectedGroup"
            >
              <span>{{ group.code }}</span>
              <span
                v-if="!group.shelve_on"
                class="ml-0.5 has-text-danger has-text-weight-bold"
              >
                (下架)
              </span>
            </b-checkbox>
          </b-collapse>
        </div>
      </b-field>

      <hr />

      <b-field horizontal :label="$t('attributes.update_items')">
        <div class="columns is-multiline is-mobile">
          <b-checkbox
            v-model="selectedAllFields"
            class="column is-12 is-marginless"
            @input="onSelectedAllFields"
          >
            {{ $t('attributes.select_all') }}
          </b-checkbox>
          <b-checkbox
            v-for="field in fields"
            v-model="form.fields"
            :key="field.key"
            :native-value="field.key"
            class="column is-3 is-marginless"
            @input="onSelectedField"
          >
            <p class="has-text-weight-medium" :style="{ color: field.color }">
              {{ field.name }}
            </p>
          </b-checkbox>
        </div>
      </b-field>

      <b-field horizontal>
        <b-button
          disabled="disabled"
          :loading="sending"
          type="is-primary"
          native-type="submit"
          style="width: 100%; margin-top: 20px;"
        >
          {{ $t('attributes.update_data') }}
        </b-button>
      </b-field>
    </form>

    <b-loading :active.sync="loading" :is-full-page="false"></b-loading>
  </section>
</template>

<script>
import { TRAVEL_GROUPS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'OverrideForm',

  props: {
    travelGroup: {
      required: true,
      type: Object
    }
  },
  data() {
    const shelveName = `${
      this.travelGroup.shelve_on ? '複寫為上架' : '複寫為下架'
    }`

    return {
      loading: false,
      sending: false,

      group_code: this.travelGroup.code,
      group_name: this.travelGroup.name,

      selectedAllFields: false,
      showExpiredGroups: false,
      fields: [
        { key: 'name', name: '團名', color: 'black' },
        { key: 'alias', name: '團別大標', color: 'black' },
        {
          key: 'operator_remark',
          name: '團控表備註',
          color: 'black'
        },
        { key: 'airline', name: '航空公司', color: 'black' },
        { key: 'shelve_on', name: shelveName, color: 'black' },
        { key: 'situation', name: '銷售狀態', color: 'black' },
        { key: 'attributes', name: '屬性', color: 'black' },
        { key: 'doc_url', name: 'PDF檔連結', color: 'black' },

        { key: 'cost', name: '價格(進階)維護', color: 'darkgreen' },
        { key: 'price_remark', name: '團費說明', color: 'darkgreen' },

        { key: 'product_cover', name: '個團圖片', color: 'brown' },
        { key: 'route_picture', name: '路線圖片', color: 'brown' },
        { key: 'banner_picture', name: '內頁大圖', color: 'brown' },

        { key: 'transfer', name: '航班交通', color: 'blue' },
        { key: 'voyage', name: '航程管理', color: 'blue' },
        { key: 'traffic', name: '交通說明', color: 'blue' },
        { key: 'feature', name: '行程特色', color: 'blue' },
        { key: 'remark', name: '促銷訊息', color: 'blue' },
        { key: 'feature_simple', name: '特色', color: 'blue' },
        { key: 'blogs', name: '行程相簿', color: 'blue' },
        { key: 'schedule', name: '每日行程', color: 'blue' },
        { key: 'food', name: '餐食住宿', color: 'blue' },
        { key: 'notes', name: '優惠說明', color: 'blue' },

        { key: 'catalogs', name: '分類', color: 'black' },
        { key: 'national_flag', name: '國旗', color: 'black' },
        { key: 'weather', name: '城市氣象', color: 'black' },
        { key: 'blocks', name: '內頁區塊設定', color: 'black' },

        { key: 'collaborate_note', name: '企業團注意事項', color: 'blue' },
        { key: 'common_questions', name: '企業團報名表', color: 'blue' },
        { key: 'spot_questions', name: '企業團自選行程', color: 'blue' }
      ],
      selectedAllGroups: false,
      groups: [],
      moreGroups: [],
      allGroups: [],
      form: {
        fields: [],
        groups: []
      }
    }
  },
  watch: {
    travelGroup(group) {
      this.group_code = group.code
      this.group_name = group.name

      this.selectedAllFields = false
      this.form.fields = []

      this.selectedAllGroups = false
      this.groups = []
      this.moreGroups = []
      this.form.groups = []

      const shelveName = `${group.shelve_on ? '複寫為上架' : '複寫為下架'}`
      this.fields = this.fields.map(f => {
        if (f.key === 'shelve_on') {
          return {
            ...f,
            name: shelveName
          }
        } else {
          return f
        }
      })

      this.loadGroups()
    }
  },
  mounted() {
    this.loadGroups()
  },
  methods: {
    async loadGroups() {
      const api = `${TRAVEL_GROUPS_API}/${
        this.group_code
      }/related-groups?show_expired=${
        this.showExpiredGroups ? 'true' : 'false'
      }`

      try {
        this.loading = true
        const res = await this.axios.get(api)
        this.allGroups = res.data.data
        if (this.allGroups.length > 9) {
          this.groups = this.allGroups.slice(0, 9)
          this.moreGroups = this.allGroups.slice(9, this.allGroups.length)
        } else {
          this.groups = this.allGroups
          this.moreGroups = []
        }
        this.form.groups = []
      } catch (e) {
        this.groups = []
        this.moreGroups = []
        this.form.groups = []

        notifyService.fetch_error('related_groups', e)
      } finally {
        this.loading = false
      }
    },
    onSelectedAllFields(selected) {
      if (selected) {
        this.form.fields = this.fields.map(g => g.key)
      } else {
        this.form.fields = []
      }
    },
    onSelectedField() {
      this.selectedAllFields = this.form.fields.length === this.fields.length
    },
    onShowExpiredGroups() {
      this.loadGroups()
    },
    onSelectedAllGroups(selected) {
      if (selected) {
        this.form.groups = this.allGroups.map(g => g.code)
      } else {
        this.form.groups = []
      }
    },
    onSelectedGroup() {
      this.selectedAllGroups = this.form.groups.length === this.groups.length
    },
    async onSend() {
      if (this.form.fields.length === 0) {
        return notifyService.error('至少需選擇一個複寫欄位')
      }

      if (this.form.groups.length === 0) {
        return notifyService.error('至少需選擇一個旅行團')
      }

      const api = `${TRAVEL_GROUPS_API}/${this.travelGroup.code}/related-groups`
      const data = {
        fields: this.form.fields.join(','),
        groups: this.form.groups.join(',')
      }

      try {
        this.loading = true
        this.sending = true
        await this.axios.put(api, data)
        if (this.form.fields.join(',').indexOf('shelve_on') !== -1) {
          await this.loadGroups()
        }
        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.loading = false
        this.sending = false
      }
    }
  }
}
</script>
